import axios from 'axios';

class StudentService {
  getAll(moderatorId) {
    return axios.get(`/students/all/${moderatorId}`);
  }

  get(id) {
    return axios.get(`/students/${id}`);
  }

  create(data) {
    return axios.post('/students', data);
  }

  delete(id) {
    return axios.delete(`/students/${id}`);
  }

  deleteDoc(data) {
    return axios.delete(`/students/deleteDoc/${data.id}/${data.studentId}`);
  }

  reportDeleteDoc(data) {
    return axios.post('/students/reportDeleteDoc', data);
  }

  findByTitle(title) {
    return axios.get(`/students?title=${title}`);
  }

  // Course routes

  applyToCourse(data) {
    return axios.post('/applications/create', data);
  }

  getAllApplications(data) {
    return axios.post(`/applications/all`, data);
  }

  deleteApplication(id) {
    return axios.delete(`/applications/${id}`);
  }

  getApplication(id) {
    return axios.get(`/applications/${id}`);
  }

  insertMessage(data) {
    return axios.post('/applications/insertMessage', data);
  }

  updateMessageStatus(data) {
    return axios.post('/applications/updateMessageStatus', data);
  }

  updateStatus(data) {
    return axios.post('/applications/updateStatus', data);
  }

  updateSeenMessages(data) {
    return axios.post('/applications/updateSeenMessages', data);
  }

  getTeamLeaders(id) {
    return axios.get(`/applications/getTeamLeaders/${id}`);
  }

  updateStudentAdvisor(data) {
    return axios.post(`/applications/updateStudentAdvisor`, data);
  }

  createOldStudent(data) {
    return axios.post(`/students/create-old-students`, data);
  }

  updateOldStudentModerators(data) {
    return axios.post(`/students/update-old-students-moderators`, data);
  }

  oldStudentApplication(data) {
    return axios.post(`/applications/oldStudentApplication`, data);
  }

  updateStudentCell(data) {
    return axios.post(`/students/updateStudentCell`, data);
  }

  messageInvite(data) {
    return axios.post(`/applications/messageInvite`, data);
  }

  moveStudentsOld(data) {
    return axios.post(`/students/move-students-to-old`, data);
  }

  uploadPrintScreen(data) {
    return axios.post(`/students/uploadPrintScreen`, data);
  }

  deletePrintScreen(data) {
    return axios.post(`/students/deletePrintScreen`, data);
  }

  uploadProfileImage(data) {
    return axios.post(`/students/uploadProfileImage`, data);
  }

  // Student finance

  updateSFE(data) {
    return axios.post(`/students/updateSFE`, data);
  }

  updateSFEStatus(data) {
    return axios.post(`/students/updateSFEStatus`, data);
  }

  markMessageAsUnseen(data) {
    return axios.post(`/students/markMessageAsUnseen`, data);
  }

  queryFieldOptions(data) {
    return axios.post('/applications/queryFieldOptions', data);
  }

  getStudentMessages(id) {
    return axios.get(`/students/getStudentMessages/${id}`);
  }

  getSFE(id) {
    return axios.get(`/students/getSFE/${id}`);
  }

  fetchIntakes(data) {
    return axios.post('/students/fetchIntakes', data);
  }

  approveStudent(data) {
    return axios.post('students/approve-student', data);
  }

  approveStudentEmail(data) {
    return axios.post('students/approve-student-email', data);
  }

  adminApproval(data) {
    return axios.post('students/updateAdmin', data);
  }

  resendEmail(data) {
    return axios.post('students/resendEmail', data);
  }
}

export default new StudentService();
